import { Link, NavLink } from "react-router-dom";
import clsx from "clsx";
import { useTheme } from "../lib/useTheme";
import type { ThemeChoice } from "../lib/useTheme";
import { useLocale } from "../lib/i18n";

export function TopBar() {
  const { theme, setTheme } = useTheme();
  const { t } = useLocale();

  const nav = [
    { to: "/", label: t.navPrayer },
    { to: "/calendar", label: t.navCalendar },
    { to: "/converter", label: t.navConverter },
    { to: "/events", label: t.navEvents }
  ];

  return (
    <div style={{ position: "sticky", top: 0, zIndex: 50, backdropFilter: "blur(14px)" }}>
      <div style={{ borderBottom: "1px solid var(--border)", background: "var(--topbar-bg)" }}>
        <div className="container" style={{ padding: "14px 16px" }}>
          <div className="row" style={{ justifyContent: "space-between" }}>
            <Link to="/" className="row" style={{ gap: 10 }}>
              <div
                aria-hidden="true"
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 10,
                  border: "1px solid var(--accent-border)",
                  background: "var(--accent-bg)",
                  boxShadow: "var(--shadow-sm)"
                }}
              />
              <div className="col" style={{ gap: 2 }}>
                <div style={{ fontWeight: 800, letterSpacing: "-0.02em" }}>Akhirah Projects</div>
                <div style={{ fontSize: 12, color: "var(--muted)" }}>{t.brandSubtitle}</div>
              </div>
            </Link>

            <div className="row" style={{ gap: 8, flexWrap: "wrap", justifyContent: "flex-end" }}>
              {nav.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  className={({ isActive }) =>
                    clsx("btn", isActive && "btnActive")
                  }
                >
                  {n.label}
                </NavLink>
              ))}
              <select
                className="themeSelect"
                value={theme}
                onChange={(e) => setTheme(e.target.value as ThemeChoice)}
                aria-label={t.themeAria}
              >
                <option value="system">{t.themeSystem}</option>
                <option value="light">{t.themeLight}</option>
                <option value="dark">{t.themeDark}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
